import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  defaultChatContext,
  defaultChatState,
  IChatContext,
} from '../types/context';
import { TChatConfig } from '../types/entity';
import { WELCOME_MESSAGE_ID } from '../utils';

import useReducer from './useReducer';

const ChatContext = React.createContext<IChatContext>(defaultChatContext);

ChatContext.displayName = 'Chat';

// eslint-disable-next-line react-refresh/only-export-components
export const useChatContext = () => React.useContext(ChatContext);

interface Props {
  children: React.ReactNode;
  config: TChatConfig;
  name: string;
}

export const ChatProvider = ({ children, config, name }: Props) => {
  const { t } = useTranslation('chat');
  const [state, dispatch] = useReducer({
    ...defaultChatState,
    config,
    messages: [
      {
        content: t('message.welcome', { name }),
        id: WELCOME_MESSAGE_ID,
        role: 'ASSISTANT',
      },
    ],
    name,
  });
  const value = { dispatch, state };

  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
};
